import { Link } from 'react-router';
import { APP_NAME } from '@/lib/constants';

export default function AboutPage() {
  return (
    <div className="min-h-screen bg-white">
      <header className="border-b border-border">
        <div className="mx-auto max-w-7xl flex items-center justify-between px-4 py-3 sm:px-6 lg:px-8">
          <Link to="/" className="text-primary font-bold text-xl">{APP_NAME}</Link>
          <Link to="/" className="text-sm text-text-secondary hover:text-text transition-colors">Back to Home</Link>
        </div>
      </header>

      <main className="mx-auto max-w-3xl px-4 py-16 sm:px-6 lg:px-8">
        <h1 className="text-3xl sm:text-4xl font-bold tracking-tight text-text">About {APP_NAME}</h1>

        <section className="mt-8 prose prose-gray max-w-none">
          <h2 className="text-xl font-semibold mt-8">Our Mission</h2>
          <p className="mt-3 text-text-secondary leading-relaxed">
            GetIntoCollege was created to simplify the college admission process for students across India.
            We understand that finding the right college and course can be overwhelming — with hundreds of
            institutions, varying eligibility criteria, and complex admission timelines.
          </p>
          <p className="mt-3 text-text-secondary leading-relaxed">
            Our platform connects students with experienced admission counsellors who provide personalised
            guidance based on the student&apos;s academic profile, preferences, and budget. We help students
            identify suitable colleges, understand admission requirements, and navigate the application process.
          </p>

          <h2 className="text-xl font-semibold mt-8">What We Offer</h2>
          <ul className="mt-3 space-y-2 text-text-secondary">
            <li>Personalised college recommendations based on your academic profile</li>
            <li>Guidance on admission requirements and eligibility criteria</li>
            <li>Assistance with document preparation and verification</li>
            <li>Information about entrance exams and application deadlines</li>
            <li>Support for both undergraduate and postgraduate admissions</li>
            <li>Guidance for distance learning and online programmes</li>
          </ul>

          <h2 className="text-xl font-semibold mt-8">Important Disclaimer</h2>
          <div className="mt-3 p-4 bg-bg border border-border rounded-lg">
            <p className="text-sm text-text-secondary leading-relaxed">
              <strong>{APP_NAME} is an independent admission guidance and counselling platform.</strong>
              We are not an official government website, nor are we an official website of any specific college,
              university, or educational institution. We do not guarantee admission to any institution.
              Our role is to provide information, guidance, and counselling to help students make informed
              decisions about their education.
            </p>
            <p className="mt-3 text-sm text-text-secondary leading-relaxed">
              Admission decisions are made solely by the respective colleges and universities based on
              their own criteria. We do not influence or control admission outcomes.
            </p>
          </div>

          <h2 className="text-xl font-semibold mt-8">Service Scope</h2>
          <p className="mt-3 text-text-secondary leading-relaxed">
            Our services cover admission guidance for a wide range of programmes including engineering,
            management, medical and allied health sciences, computer applications, arts and humanities,
            commerce, law, pharmacy, nursing, diploma courses, and distance or online programmes across India.
          </p>

          <h2 className="text-xl font-semibold mt-8">Contact Us</h2>
          <p className="mt-3 text-text-secondary">
            If you have questions about our services, please visit our{' '}
            <Link to="/contact" className="text-primary hover:text-primary-dark underline">Contact page</Link>.
          </p>
        </section>
      </main>

      <footer className="border-t border-border">
        <div className="mx-auto max-w-3xl px-4 py-6 text-center text-xs text-text-secondary">
          <p>&copy; {new Date().getFullYear()} {APP_NAME}. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
}
